<template>
<div class="grid grid-cols-1 md:grid-cols-2">
    <section class="border border-gray-800 p-3">

        <div class="">
            <div class="flex">
                <label>Title for audio feature</label>
                <span v-if="errors().title" class="errormessage">{{ errors().title }}</span>
            </div>
            <input class="input-black" type="text" id="audio_title" :value="titleForAudioFeatureValue()"
            @input="$emit('update:titleForAudioFeature', $event.target.value)">
        </div>

        <div class="flex">
            <label>Add audio file</label>
            <span v-if="errors().file" class="errormessage">{{ errors().file }}</span>
        </div>
        <div class="upload-box">
            <span>
                <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('audio_feature_audio')">Upload from media library</a>
            </span>
            <span>{{ audioFileName() }}</span>
        </div>

    </section>

    <section class="border border-gray-800 p-3">
        <div class="flex">
            <label>Add background image</label>
            <span v-if="errors().file" class="errormessage">{{ errors().file }}</span>
        </div>
        <RecommendedAspectRatio uploadBoxType="audio-feature-preview" />
        <div class="upload-box">

            <div class="" v-if="!form.feature_audio_preview_images[form.current_language].from_media_library_id">
                <span>
                    <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('audio_feature_background_image')">Upload from media library</a>
                </span>
                <span class="block">{{ backgroundFileName() }}</span>
            </div>

            <div v-if="form.feature_audio_preview_images[form.current_language].from_media_library_id">
                <img :src="form.feature_audio_preview_images[form.current_language].loaded_file_path" class="logo-img">
            </div>
        </div>

    </section>

</div>
<section class="border border-gray-800 p-3">
    <div class="block text-center">
        <button v-if="!form.processing" class="btn btn-gradient" @click="saveFile"><i class="save"></i></button>
        <button v-else class="btn btn-gradient"><Spinner/></button>
    </div>
</section>

</template>

<script>
import Spinner from '@/UI/Spinner';
import RecommendedAspectRatio from '@/Pages/Media/RecommendedAspectRatio';

export default {
    components: {
        Spinner,
        RecommendedAspectRatio
    },
    props: {
      form: Object,
      saveFile: Function,
      titleForAudioFeature: String,
      changeUploadBoxState: Function,
    },
    emits: ['update:titleForAudioFeature'],
    methods: {
        errors(){
            return this.$page.props.errors;
        },
        titleForAudioFeatureValue(){
            return this.form.feature_audio_files[this.form.current_language].title;
        },
        audioFileName(){
            if(this.form.feature_audio_files[this.form.current_language].from_media_library_id)
            {
                return this.form.feature_audio_files[this.form.current_language].loaded_file_path
            } else {
                return this.form.feature_audio_files[this.form.current_language].file &&
                this.form.feature_audio_files[this.form.current_language].file.name;
            }
        },
        backgroundFileName(){
            return this.form.feature_audio_preview_images[this.form.current_language].file &&
            this.form.feature_audio_preview_images[this.form.current_language].file.name;
        }
    }
}
</script>
